import React, { memo } from 'react';
import { CTAButton } from './ui/CTAButton';
export function ProductSection() {
  return <section className="w-full py-16 bg-[#EAF6FF]" data-id="element-251">
      <div className="max-w-3xl mx-auto px-4" data-id="element-252">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-gray-900" data-id="element-253">
          📚 ¿Qué incluye exactamente el Mega Pack?
        </h2>

        <div className="space-y-8" data-id="element-254">
          {/* Tomo 1 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-255">
            <h3 className="text-2xl font-bold text-blue-600 mb-4 flex items-center gap-2" data-id="element-256">
              <span data-id="element-257">📘</span> Tomo 1 — Motricidad Fina
            </h3>
            <p className="text-gray-700 mb-4 text-lg" data-id="element-258">
              Actividades diseñadas para fortalecer la coordinación y el control
              de los movimientos de manos y dedos.
            </p>
            <p className="font-semibold text-gray-800 mb-2" data-id="element-259">
              Incluye ejercicios como:
            </p>
            <ul className="grid grid-cols-2 md:grid-cols-3 gap-2 mb-4 text-gray-600" data-id="element-260">
              <li data-id="element-261">• trazos</li>
              <li data-id="element-262">• plastilina</li>
              <li data-id="element-263">• dactilopintura</li>
              <li data-id="element-264">• trozado</li>
              <li data-id="element-265">• recortes</li>
            </ul>
            <p className="text-sm font-medium text-gray-500 bg-gray-50 p-3 rounded-lg" data-id="element-266">
              Estas actividades ayudan a preparar a los niños para escribir,
              dibujar y manipular objetos con mayor precisión.
            </p>
          </div>

          {/* Tomo 2 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-267">
            <h3 className="text-2xl font-bold text-purple-600 mb-4 flex items-center gap-2" data-id="element-268">
              <span data-id="element-269">🧠</span> Tomo 2 — Atención y Concentración
            </h3>
            <p className="text-gray-700 mb-4 text-lg" data-id="element-270">
              Actividades que estimulan la observación y el enfoque.
            </p>
            <p className="font-semibold text-gray-800 mb-2" data-id="element-271">Incluye:</p>
            <ul className="grid grid-cols-2 gap-2 mb-4 text-gray-600" data-id="element-272">
              <li data-id="element-273">• laberintos</li>
              <li data-id="element-274">• encuentra las diferencias</li>
              <li data-id="element-275">• secuencias</li>
              <li data-id="element-276">• busca letras</li>
              <li data-id="element-277">• figuras que siguen</li>
            </ul>
            <p className="text-sm font-medium text-gray-500 bg-gray-50 p-3 rounded-lg" data-id="element-278">
              Perfecto para desarrollar la concentración y la capacidad de
              resolver pequeños desafíos.
            </p>
          </div>

          {/* Tomo 3 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-279">
            <h3 className="text-2xl font-bold text-green-600 mb-4 flex items-center gap-2" data-id="element-280">
              <span data-id="element-281">🗣</span> Tomo 3 — Vocabulario
            </h3>
            <p className="text-gray-700 mb-4 text-lg" data-id="element-282">
              Actividades que ayudan a ampliar el lenguaje y el conocimiento del
              mundo.
            </p>
            <p className="font-semibold text-gray-800 mb-2" data-id="element-283">
              Incluye temas como:
            </p>
            <ul className="grid grid-cols-2 gap-2 mb-4 text-gray-600" data-id="element-284">
              <li data-id="element-285">• animales</li>
              <li data-id="element-286">• los sentidos</li>
              <li data-id="element-287">• partes del cuerpo</li>
              <li data-id="element-288">• emociones</li>
              <li data-id="element-289">• cuentos de estimulación</li>
            </ul>
            <p className="text-sm font-medium text-gray-500 bg-gray-50 p-3 rounded-lg" data-id="element-290">
              Ideal para fortalecer la comunicación y el desarrollo del
              lenguaje.
            </p>
          </div>

          {/* Tomo 4 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-291">
            <h3 className="text-2xl font-bold text-orange-600 mb-4 flex items-center gap-2" data-id="element-292">
              <span data-id="element-293">🔎</span> Tomo 4 — Razonamiento
            </h3>
            <p className="text-gray-700 mb-4 text-lg" data-id="element-294">
              Actividades diseñadas para estimular el pensamiento lógico.
            </p>
            <p className="font-semibold text-gray-800 mb-2" data-id="element-295">Incluye:</p>
            <ul className="grid grid-cols-2 md:grid-cols-3 gap-2 mb-4 text-gray-600" data-id="element-296">
              <li data-id="element-297">• relaciones</li>
              <li data-id="element-298">• conecta los puntos</li>
              <li data-id="element-299">• memoria</li>
              <li data-id="element-300">• números</li>
              <li data-id="element-301">• pensamiento lógico</li>
              <li data-id="element-302">• sumas simples</li>
              <li data-id="element-303">• coloreo numérico</li>
            </ul>
            <p className="text-sm font-medium text-gray-500 bg-gray-50 p-3 rounded-lg" data-id="element-304">
              Los niños aprenden a observar, analizar y resolver pequeños
              problemas.
            </p>
          </div>

          {/* Tomo 5 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-305">
            <h3 className="text-2xl font-bold text-red-500 mb-4 flex items-center gap-2" data-id="element-306">
              <span data-id="element-307">✏️</span> Tomo 5 — Lectoescritura
            </h3>
            <p className="text-gray-700 mb-4 text-lg" data-id="element-308">
              Actividades que introducen a los niños en el mundo de las letras.
            </p>
            <p className="font-semibold text-gray-800 mb-2" data-id="element-309">Incluye:</p>
            <ul className="grid grid-cols-2 md:grid-cols-3 gap-2 mb-4 text-gray-600" data-id="element-310">
              <li data-id="element-311">• letras y vocales</li>
              <li data-id="element-312">• silabario</li>
              <li data-id="element-313">• conciencia silábica</li>
              <li data-id="element-314">• sopa de letras</li>
              <li data-id="element-315">• completar vocales</li>
              <li data-id="element-316">• memoria verbal</li>
            </ul>
            <p className="text-sm font-medium text-gray-500 bg-gray-50 p-3 rounded-lg" data-id="element-317">
              Perfecto para preparar a los niños para la lectura y la escritura.
            </p>
          </div>
        </div>

        <div className="mt-12" data-id="element-318">
          <CTAButton data-id="element-319" />
        </div>
      </div>
    </section>;
}